import {
    apiRequest,
    rekapDetail
} from "../../../../../services/adapters/kepegawaian/rekapAbsensiService"

class DetailRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", rekapDetail, {
            params: query
        }, true)
    }
}

export default DetailRepository